export default "__VITE_ASSET__DzJUt$02__"